import React, { useContext } from 'react';
import { formatPriceGBP } from '../../../../helpers/formatPrice';
import { MessagePropertiesContext } from '../../../../contexts/messageProperties';
import { VariantOption } from '../../financeModal/variantSelector/variantSelector';
import { INPUT_NAME } from './form';

interface QuickSelectProps {
  handleChange: any;
  selectedAmount: string;
  quickSelectOptions: number[];
}

function QuickSelect({ handleChange, selectedAmount, quickSelectOptions }: QuickSelectProps): React.ReactElement {
  const [formattedMessage] = useContext(MessagePropertiesContext);

  return (
    <div className="quick-select">
      <span className="quick-select__heading">
        {formattedMessage({ id: 'product.giftcard.quick.select.heading', fallback: 'Choose An Amount' })}
      </span>
      {quickSelectOptions && (
        <ul className="quick-select__selector">
          {quickSelectOptions.map((amount) => (
            <VariantOption
              key={amount}
              name={INPUT_NAME}
              id={amount.toString()}
              checked={selectedAmount === amount.toString()}
              value={amount.toString()}
              isAvailableForPurchase
              label={formatPriceGBP(amount)}
              productCode={amount.toString()}
              handleChange={handleChange}
            />
          ))}
        </ul>
      )}
    </div>
  );
}

export default QuickSelect;
